import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React from "react";
import { styled } from "@mui/material/styles";
const StyledTableContainer = styled(TableContainer)(() => ({
    borderRadius: '6px',
    backgroundColor: 'white',
    border: '1px solid #E8E6E6',
    width: 'unset',
}));
const StyledTitleTableCell = styled(TableCell)(() => ({
    textAlign: 'center',
    backgroundColor: '#F9F9F9',
    color: '#030712',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    padding: '6px',
    fontSize: '12px'
}));
const StyleHeaderTableCell = styled(TableCell)(() => ({
    textAlign: 'center',
    backgroundColor: '#F9F9F9',
    color: '#84818A',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    padding: '6px 14px',
    fontSize: '12px',
    whiteSpace: 'nowrap'
}));
const StyledRowTableCell = styled(TableCell)(() => ({
    textAlign: 'left',
    padding: '9px 14px',
    backgroundColor: '#F9F9F9',
    fontWeight: 'bold',
    border: '1px solid #E8E6E6',
}));
const StyledDataTableCell = styled(TableCell)(() => ({
    textAlign: 'center',
    fontWeight: '600',
    padding: '9px 24px',
    color: '#2E2C34'
}));
const SensitivityAnalysisTable = ({ titleName, indexTitle, columnsTitle, columnHeaders, rowHeaders, data }) => {
    return (_jsxs(StyledTableContainer, { children: [_jsxs(TableHead, { children: [_jsx(TableRow, { children: _jsx(StyledTitleTableCell, { colSpan: 4, children: titleName }) }), _jsxs(TableRow, { children: [_jsx(StyleHeaderTableCell, { children: indexTitle }), _jsx(StyleHeaderTableCell, { colSpan: 3, children: columnsTitle })] }), _jsxs(TableRow, { children: [_jsx(StyleHeaderTableCell, {}), columnHeaders.map((header, index) => {
                                return (_jsx(StyleHeaderTableCell, { children: header }, index));
                            })] })] }), _jsx(TableBody, { children: rowHeaders.map((row, index) => {
                    return (_jsxs(TableRow, { children: [_jsx(StyledRowTableCell, { children: row }), data[index].map((value, index) => {
                                return (_jsx(StyledDataTableCell, { children: value }, index));
                            })] }, index));
                }) })] }));
};
export default SensitivityAnalysisTable;
